import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Create the base store with accounts configuration
const accountsBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/accounts",
  name: "AccountsStoreRefactor",
  objectName: "Account", // Auto-generates CRUD success messages
  enableCache: true, // 5-minute cache for accounts
  actionCableChannel: "AccountChannel", // Use class name, not stream name
  infiniteLoading: true, // Support pagination for account lists
});

export const useAccountsStoreRefactor = defineStore("accountsRefactor", {
  ...accountsBaseStore,

  state: () => ({
    ...accountsBaseStore.state(),
  }),

  getters: {
    ...accountsBaseStore.getters,

    // Expose base store configuration for tests
    endpoint: () => "/api/v1/accounts",

    // Backward compatibility getters - sync with data array
    accounts: (state) => state.data || [],
    getAccounts: (state) => state.data || [],

    // Backward compatibility: getAccountById now aliases to standard getById
    getAccountById: (state) => (id) => {
      // Use the inherited base getById method for consistency
      const baseGetById = accountsBaseStore.getters.getById;
      return baseGetById(state)(id);
    },
  },

  actions: {
    ...accountsBaseStore.actions,

    // All methods including search are now fully inherited from base store
  },
});
